export const changeResponseTypeAction = (state, action) => {
  state.questionList.forEach((question) => {
    if (question.id === action.payload.id) {
      question.response_type = action.payload.response_type;
    }
  });

  state.hasUnsavedChanges = true;
};
